/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Error_Category_Publish1Inputs */

const vi_cmspost_error_category_publish1 = /** @type {(inputs: Cmspost_Error_Category_Publish1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn chuyên mục trước khi đăng bài.`)
};

/**

* @param {Cmspost_Error_Category_Publish1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_error_category_publish1 = /** @type {((inputs?: Cmspost_Error_Category_Publish1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Error_Category_Publish1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_error_category_publish1(inputs)
});
export { cmspost_error_category_publish1 as "cmsPost_error_category_publish" }